import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "separator"
}
const _hoisted_2 = { scope: "row" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["tabindex", "role", "onKeydown"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableRow = _resolveComponent("TableRow", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.index !== 0)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("td", { class: "separator-td" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowData.values, (item) => {
            return (_openBlock(), _createElementBlock("th", {
              scope: "col",
              class: "separator-td",
              key: item.id
            }))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("tr", {
      class: _normalizeClass(_ctx.rowClass)
    }, [
      _createElementVNode("th", _hoisted_2, [
        _createElementVNode("span", {
          class: "title",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tdClick(_ctx.rowData.id, _ctx.rowData.noeudsEnfants))),
          onKeydown: [
            _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.tdClick(_ctx.rowData.id, _ctx.rowData.noeudsEnfants)), ["prevent"]), ["enter"])),
            _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.tdClick(_ctx.rowData.id, _ctx.rowData.noeudsEnfants)), ["prevent"]), ["space"]))
          ],
          tabindex: "0",
          role: "button"
        }, [
          (_ctx.rowData.noeudsEnfants.length > 0 && _ctx.open)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "upAllRow",
                src: this.chevronUp,
                alt: _ctx.$t('alt.replier')
              }, null, 8, _hoisted_3))
            : (_ctx.rowData.noeudsEnfants.length > 0 && !_ctx.open)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "downAllRow",
                  src: this.chevronDown,
                  alt: _ctx.$t('alt.deplier')
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.rowData.libelle), 1)
        ], 32)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowData.periodesPlanning, (item) => {
        return (_openBlock(), _createElementBlock("td", {
          key: item.id,
          class: _normalizeClass({
                selectable: _ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf,
                selected: _ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf && _ctx.isSelected(item)
            }),
          onClick: ($event: any) => (_ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf ? _ctx.onCellClick(item) : null)
        }, [
          (_ctx.displayPeriodiciteOrNot)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                tabindex: _ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf ? 0 : -1,
                role: _ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf ? 'button' : null,
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (_ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf ? _ctx.onCellClick(item) : null), ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.selectionMode && item.etat === 'REALISE' && _ctx.isLeaf ? _ctx.onCellClick(item) : null), ["prevent"]), ["space"])
                ]
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getPeriodiciteString(item.periodicite)), 1),
                _createElementVNode("span", null, [
                  (item.etat)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "statusIcon",
                        src: _ctx.getStatusIcon(item.etat),
                        alt: _ctx.getStatusName(item.etat)
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (item.isOberservationAlarmante)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: this.warning,
                        alt: _ctx.$t('alt.observation.alarmante')
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ], 40, _hoisted_6))
            : _createCommentVNode("", true)
        ], 10, _hoisted_5))
      }), 128))
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedChildren, (item) => {
      return (_openBlock(), _createBlock(_component_TableRow, {
        rowData: item,
        key: item.libelle,
        rowClass: _ctx.getChildClass,
        openAll: _ctx.openAll,
        selectionMode: _ctx.selectionMode,
        "selected-report-ids": _ctx.selectedReportIds,
        "selected-ui-ids": _ctx.selectedUiIds,
        onOpen: _ctx.emitOpen,
        onEmitOpenModal: _ctx.emitOpenModal,
        onCellClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cellClick', $event)))
      }, null, 8, ["rowData", "rowClass", "openAll", "selectionMode", "selected-report-ids", "selected-ui-ids", "onOpen", "onEmitOpenModal"]))
    }), 128))
  ], 64))
}